import React, { useMemo } from 'react'
import { MapPinProps, MapPinTypeVariant } from '../types'
import { MapPinIcon } from './MapPinIcon'
import SvgIcon from '@mui/material/SvgIcon'
import Box from '@mui/material/Box'

type Props = {
  size: number
  width?: number
  height?: number
  bgColor: string
  iconColor?: string
  variant: MapPinProps['variant']
  iconSize: number
  count: number
  multitenant: boolean
}

export function MapPinBody({
  size,
  width,
  height,
  bgColor,
  variant,
  iconSize,
  count,
  iconColor = 'white',
  multitenant,
}: Props) {
  const finalWidth = width ?? size
  const finalHeight = height ?? size * 2.1

  const pinIconStyle = useMemo(() => {
    let styels: React.CSSProperties | undefined = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '60%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      pointerEvents: 'none',
    }

    if (multitenant) {
      styels = {
        ...styels,
        top: '2px',
        left: '0.2px',
      }
      return styels
    }

    if (variant === MapPinTypeVariant.Opportunity) {
      styels = {
        ...styels,
        top: '5px',
      }
    }

    if (
      variant === MapPinTypeVariant.PendingLead ||
      variant === MapPinTypeVariant.DraftLead
    ) {
      styels = {
        ...styels,
        top: '2px',
      }
    }

    return styels
  }, [multitenant, variant])

  return (
    <Box
      sx={{
        position: 'relative',
        width: finalWidth,
        height: finalHeight,
        '&:hover .pin-body-path': {
          fill: '#3E98FF',
        },
      }}
    >
      <SvgIcon
        viewBox="0 0 27 56"
        sx={{
          width: finalWidth,
          height: finalHeight,
          display: 'block',
          overflow: 'visible',
          filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.2))',
        }}
      >
        <path
          className="pin-body-path"
          d="M13.4385 0.5L25.667 16.6777C26.1553 17.3238 26.3007 18.1663 26.0566 18.9385L14.5 55.5H12.9473L0.958008 18.9277C0.705836 18.1584 0.84109 17.3142 1.32227 16.6631L13.2666 0.5H13.4385Z"
          fill={bgColor}
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </SvgIcon>
      <div style={pinIconStyle}>
        <MapPinIcon
          variant={variant}
          size={iconSize}
          isGroup={count > 1}
          color={iconColor}
        />
      </div>
    </Box>
  )
}
